import { useCallback } from 'react';
import useBooleanState from './useBooleanState';
import { useValidationErrors } from './useValidationErrors';

export function useAsyncAction<T extends any[] = any[]>(action: (...args: T) => Promise<void>, initiallyLoading?: boolean) {
    const [error, validation, setError] =
        useValidationErrors<T extends [infer X, ...any[]] ? (X extends Record<string, any> ? keyof X : never) : never>();
    const [isBusy, setIsBusy] = useBooleanState(initiallyLoading);
    const callback = useCallback(async (...args: T) => {
        try {
            setIsBusy.toTrue();
            setError(null);
            await action(...args);
        } catch (e) {
            setError(e);
        } finally {
            setIsBusy.toFalse();
        }
    }, []);
    const reset = useCallback(() => {
        setError(undefined);
        setIsBusy.toFalse();
    }, []);
    return [callback, isBusy, error, validation, reset] as const;
}
